module.exports = __webpack_public_path__ + "static/img/onlineImg1.72f85277.jpg";